<template>
    <div class="i-surveys-form-input">
        <form-item v-bind="$attrs">
            <div class="multi-dropdown-list">
                <div
                    class="multi-dropdown-unit"
                    v-for="(unit, index) in options"
                    :key="index"
                >
                    <span class="unit-label">{{ unit.name }}</span>
                    <van-field
                        :value="getUnitDisplay(index)"
                        :placeholder="'请选择' + unit.name"
                        :rules="[]"
                        :readonly="true"
                        :name="`${itemKey}_${index}`"
                        :border="false"
                        @click-input="openPicker(index)"
                    >
                        <template #right-icon>
                            <van-icon
                                name="arrow-down"
                                size="12"
                                :color="getUnitDisplay(index) ? '#323233' : '#c8c9cc'"
                            />
                        </template>
                    </van-field>
                </div>
            </div>
        </form-item>

        <van-popup v-model="show" position="bottom" style="height: 50%">
            <div class="popup-wrapper">
                <div class="popup-header">
                    <van-search
                        v-model="search"
                        show-action
                        placeholder="请输入搜索"
                        @search="onSearch"
                        @cancel="onCancel"
                    />
                </div>

                <div class="popup-body">
                    <van-radio-group v-model="radio">
                        <van-cell-group>
                            <van-cell
                                v-for="(opt, oIndex) in activeUnitOptions"
                                :key="oIndex"
                                :title="opt.name"
                                clickable
                                @click="selectUnitOption(opt)"
                            >
                                <template #right-icon>
                                    <van-radio
                                        :name="opt.name"
                                        checked-color="var(--color-primary)"
                                    />
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </van-radio-group>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import FormItem from './form-item.vue'

const SEPARATOR = '@%_@%'

export default {
    components: { FormItem },
    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        rules: {
            type: Array,
            default: () => ([])
        },
        options: {
            type: Array,
            default: () => ([])
        },
        itemKey: {
            type: String,
            default: ''
        }
    },
    computed: {
        modelValue: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        },
        unitValues () {
            if (!this.modelValue) return []
            return this.modelValue.split(SEPARATOR)
        },
        activeUnitOptions () {
            if (this.activeIndex === -1 || !this.options[this.activeIndex]) {
                return []
            }
            const list = this.options[this.activeIndex].selectOptionList || []
            if (!this.search) {
                return list
            }
            const keyword = this.search.toLowerCase()
            return list.filter(opt => opt.name.toLowerCase().includes(keyword))
        },
        isDisabled () {
            return this.$route.query.formType === 'preview'
        }
    },
    data () {
        return {
            search: '',
            show: false,
            radio: '',
            activeIndex: -1
        }
    },
    methods: {
        getUnitDisplay (index) {
            const vals = this.unitValues
            return (vals[index] !== undefined && vals[index] !== '') ? vals[index] : ''
        },
        openPicker (index) {
            if (this.isDisabled) return
            this.activeIndex = index
            this.search = ''
            this.radio = this.unitValues[index] || ''
            this.show = true
        },
        selectUnitOption (opt) {
            const vals = [...this.unitValues]
            // Expand array if needed
            while (vals.length <= this.activeIndex) {
                vals.push('')
            }
            vals[this.activeIndex] = opt.name
            this.modelValue = vals.join(SEPARATOR)
            this.radio = opt.name
            this.show = false
            this.$emit('sumBlur')
        },
        clearUnitSelection () {
            const vals = [...this.unitValues]
            if (vals.length > this.activeIndex) {
                vals[this.activeIndex] = ''
                this.modelValue = vals.join(SEPARATOR)
            }
            this.radio = ''
        },
        onSearch () {},
        onCancel () {
            this.show = false
        }
    }
}
</script>

<style scoped>
.multi-dropdown-list {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 10px;
}

.multi-dropdown-unit {
    display: flex;
    align-items: center;
    flex: 1 1 0;
    min-width: 0;
    background: #f7f8fa;
    border-radius: 4px;
    padding: 0 10px;
    min-height: 44px;
    box-sizing: border-box;
    overflow: hidden;
}

.multi-dropdown-unit .unit-label {
    font-size: 14px;
    color: #646566;
    white-space: nowrap;
    margin-right: 4px;
    flex-shrink: 0;
}

.multi-dropdown-unit .van-field {
    flex: 1;
    min-width: 0;
    padding: 0;
}

.popup-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.popup-header {
    position: relative;
    flex-shrink: 0;
}

.popup-body {
    flex: 1;
    overflow-y: auto;
}
</style>
